
import request from '@/utils/request'

export function GetSuggestRetailPriceVerifyData(data) {
  return request({
    url: 'sales/SuggestRetailPrice/GetSuggestRetailPriceVerifyData',
    method: 'post',
    data
  })
}

export function ImportGoods(data) {
  return request({
    url: 'sales/SuggestRetailPrice/ImportGoods',
    method: 'post',
    data
  })
}
export function BatchLoseEffectSuggestRetailPrice(data) {
  return request({
    url: 'sales/SuggestRetailPrice/BatchLoseEffect',
    method: 'post',
    data
  })
}
// 零售价
export function GetSuggestRetailPriceVerifyDataRetailPrice(data) {
  return request({
    url: 'sales/RetailPrice/GetRetailPriceVerifyData',
    method: 'post',
    data
  })
}

export function ImportGoodsRetailPrice(data) {
  return request({
    url: 'sales/RetailPrice/ImportGoods',
    method: 'post',
    data
  })
}

export function BatchLoseEffectRetailPrice(data) {
  return request({
    url: 'sales/RetailPrice/BatchLoseEffect',
    method: 'post',
    data
  })
}

// 获取零售价格查询-未来(包含今天) (Auth)/api/RetailPrice/GetRetailPriceFeturePageList
export function GetRetailPriceFeturePageList(data) {
  return request({
    url: 'sales/RetailPrice/GetRetailPriceFeturePageList',
    method: 'post',
    data
  })
}

// 获取零售价格查询-历史 (Auth) /api/RetailPrice/GetRetailPriceHistoryPageList
export function GetRetailPriceHistoryPageList(data) {
  return request({
    url: 'sales/RetailPrice/GetRetailPriceHistoryPageList',
    method: 'post',
    data
  })
}
// 预计零售价
export function GetRetailPriceWarningverifyData(data) {
  return request({
    url: 'sales/RetailPriceWarning/GetRetailPriceWarningverifyData',
    method: 'post',
    data
  })
}

export function ImportWarning(data) {
  return request({
    url: 'sales/RetailPriceWarning/ImportGoods',
    method: 'post',
    data
  })
}

export function BatchLoseEffect(data) {
  return request({
    url: 'sales/RetailPriceWarning/BatchLoseEffect',
    method: 'post',
    data
  })
}
// 达播品类
export function GetDaboClassVerifyData(data) {
  return request({
    url: 'sales/DaboClassWarning/GetDaboClassVerifyData',
    method: 'post',
    data
  })
}

export function ImportDaboClassWarning(data) {
  return request({
    url: 'sales/DaboClassWarning/ImportGoods',
    method: 'post',
    data
  })
}
export function BatchLoseEffectDaboClass(data) {
  return request({
    url: 'sales/DaboClassWarning/BatchLoseEffect',
    method: 'post',
    data
  })
}

// 获取未来价格查询导出 (Auth)  /api/RetailPrice/GetRetailPriceFetureExport
export function GetRetailPriceFetureExport(data) {
  return request({
    url: 'sales/RetailPrice/GetRetailPriceFetureExport',
    responseType: 'blob',
    method: 'post',
    data
  })
}

// 获取历史价格查询导出 (Auth) /api/RetailPrice/RetailPriceHistoryExport
export function RetailPriceHistoryExport(data) {
  return request({
    url: 'sales/RetailPrice/RetailPriceHistoryExport',
    responseType: 'blob',
    method: 'post',
    data
  })
}

// 零售价获取生效中的详情数据
export function GetEffectedRetailPriceData(data) {
  return request({
    url: 'sales/RetailPrice/GetEffectedRetailPriceData',
    method: 'post',
    data
  })
}

// 预警价格获取生效中的详情数据
export function GetEffectedRetailWarningPriceData(data) {
  return request({
    url: 'sales/RetailPriceWarning/GetEffectedRetailWarningPriceData',
    method: 'post',
    data
  })
}
// -----------------------------品牌折扣-----------------------------
// 品牌折扣 /api/BrandDiscount/GetEffectedRetailPriceData
export function GetEffectedBrandDiscountData(data) {
  return request({
    url: 'sales/BrandDiscount/GetEffectedRetailPriceData',
    method: 'post',
    data
  })
}
// 客户导入 /api/BrandDiscount/ImportCustomer
export function ImportCustomer(data) {
  return request({
    url: 'sales/BrandDiscount/ImportCustomer',
    method: 'post',
    data
  })
}
// 客户分类导入 /api/BrandDiscount/ImportCustomerCategory
export function ImportCustomerCategory(data) {
  return request({
    url: 'sales/BrandDiscount/ImportCustomerCategory',
    method: 'post',
    data
  })
}
// 批量失效 /api/BrandDiscount/BatchLoseEffect
export function BatchLoseEffectBrandDiscount(data) {
  return request({
    url: 'sales/BrandDiscount/BatchLoseEffect',
    method: 'post',
    data
  })
}
// -----------------------------供货价-----------------------------
//  获取品牌供货价
export function GetEffectedGoodsSupplyData(data) {
  return request({
    url: 'sales/GoodsSupplyPrice/GetEffectedGoodsSupplyData',
    method: 'post',
    data
  })
}
// 获取品牌锚定价 /api/GoodsSupplyPrice/GetGoodsRetailPriceData
export function GetGoodsRetailPriceData(data) {
  return request({
    url: 'sales/GoodsSupplyPrice/GetGoodsRetailPriceData',
    method: 'post',
    data
  })
}

// 导入  /api/GoodsSupplyPrice/ImportGoods
export function ImportGoodsSupplyPrice(data) {
  return request({
    url: 'sales/GoodsSupplyPrice/ImportGoods',
    method: 'post',
    data
  })
}
// 记录 /api/GoodsSupplyPrice/BatchLoseEffect
export function BatchLoseEffectGoodsSupplyPrice(data) {
  return request({
    url: 'sales/GoodsSupplyPrice/BatchLoseEffect',
    method: 'post',
    data
  })
}
// -----------------------------可售-----------------------------
// 导入商品  /api/CanGoodsSeller/ImportGoods
export function ImportGoodsSeller(data) {
  return request({
    url: 'sales/CanGoodsSeller/ImportGoods',
    method: 'post',
    data
  })
}

// 导入客户分类 /api/CanGoodsSeller/ImportCustomerCategory
export function ImportCustomerCategorySeller(data) {
  return request({
    url: 'sales/CanGoodsSeller/ImportCustomerCategory',
    method: 'post',
    data
  })
}

// 导入客户 /api/CanGoodsSeller/ImportCustomer
export function ImportCustomerSeller(data) {
  return request({
    url: 'sales/CanGoodsSeller/ImportCustomer',
    method: 'post',
    data
  })
}
// 供货价 获取供货价格查询-未来(包含今天) (Auth)
export function GetSupplyPriceFeturePageList(data) {
  return request({
    url: 'sales/GoodsSupplyPrice/GetSupplyPriceFeturePageList',
    method: 'post',
    data
  })
}

// 获取供货价格查询-未来(包含今天)查询导出 (Auth) /api/GoodsSupplyPrice/GetSupplyPriceFetureExport
export function GetSupplyPriceFetureExport(data) {
  return request({
    url: 'sales/GoodsSupplyPrice/GetSupplyPriceFetureExport',
    responseType: 'blob',
    method: 'post',
    data
  })
}

// 关闭 /api/CanGoodsSeller/CloseApply
export function CloseApply(data) {
  return request({
    url: 'sales/CanGoodsSeller/CloseApply',
    method: 'post',
    data
  })
}

// 客户型-商品-导入/api/CanGoodsSeller/ImportCustomer
export function ImportCustomerCanGoodsSeller(data) {
  return request({
    url: 'sales/CanGoodsSeller/ImportCustomer',
    method: 'post',
    data
  })
}
// 促销商品 批量失效 (Auth) /api/PromoteActivity/BatchLoseEffect
export function BatchLoseEffectPromoteActivity(data) {
  return request({
    url: 'sales/PromoteActivity/BatchLoseEffect',
    method: 'post',
    data
  })
}
// -------------------------------------订单管理中心-------------------------------------
// 获取币种汇率信息 (Auth) get /api/FxErpManualTrade/GetOrderCurrencyRate
export function GetOrderCurrencyRate(data) {
  return request({
    url: 'sales/FxErpManualTrade/GetOrderCurrencyRate',
    method: 'get',
    params: data
  })
}
// 导入商品 (Auth) post  /api/FxErpManualTrade/ImportGoods
export function FxErpManualTradeImportGoods(data) {
  return request({
    url: 'sales/FxErpManualTrade/ImportGoods',
    method: 'post',
    data
  })
}

// 刷新库存（货品编码数组） post /api/sales/FxErpManualTrade/StockProductSync
export function FxErpManualTradeStockProductSync(data) {
  return request({
    url: 'sales/FxErpManualTrade/StockProductSync',
    method: 'post',
    data
  })
}
// 计算促销活动规则赠送商品 (Auth) post  /api/FxErpManualTrade/ImportGoods
export function CalPromoteActivityRuleGiftGoods(data) {
  return request({
    url: 'sales/PromoteActivity/CalPromoteActivityRuleGiftGoods',
    method: 'post',
    data
  })
}

// 获取六点品牌
export function GetCoreBrands(data) {
  return request({
    url: 'sales/FxErpManualTrade/GetCoreBrands',
    method: 'get',
    params: data
  })
}

// 销售出库单弹框列表
export function GetFxStockOutOrderPageList(data) {
  return request({
    url: 'sales/FxRefundTrade/GetFxStockOutOrderPageList',
    method: 'post',
    data
  })
}

// 销售资源额度导入 /api/sales/SalesResourceQuota/import
export function ImportSalesResourceQuota(data) {
  return request({
    url: 'sales/SalesResourceQuota/import',
    method: 'post',
    data
  })
}

// 作废 /api/FxRefundTrade/CancelRefundTrade

export function CancelRefundTrade(data) {
  return request({
    url: 'sales/FxRefundTrade/CancelRefundTrade',
    method: 'post',
    data
  })
}

// 停止入库
export function StopStockIn(data) {
  return request({
    url: 'sales/FxRefundTrade/StopStockIn',
    method: 'post',
    data
  })
}
// 强制审核 /api/FxErpManualTrade/FinishFxOrderApprove
export function FinishFxOrderApprove(data) {
  return request({
    url: 'sales/FxErpManualTrade/FinishFxOrderApprove',
    method: 'post',
    data
  })
}

export function GetTradeShop(data) {
  return request({
    url: 'sales/FxErpManualTrade/GetTradeShop',
    method: 'get',
    params: data
  })
}
// 根据客户和客商Id,账号类型获取分销账号信息列表 (Auth)
export function GetFxAccountList(data) {
  return request({
    url: 'nc/FxCustAccount/GetFxAccountList',
    method: 'get',
    params: data
  })
}

// 获取用户品牌权限 (Auth)
export function GetUserBrandPermission(data) {
  return request({
    url: 'sales/UserRole/GetUserBrandPermission',
    method: 'get',
    params: data
  })
}

// 获取用户店铺权限 (Auth)
export function GetUserShopPermission(data) {
  return request({
    url: 'sales/UserRole/GetUserShopPermission',
    method: 'get',
    params: data
  })
}
// 获取额度和退款金额
export function GetQuateAmount(data) {
  return request({
    url: 'sales/FxErpManualTrade/GetQuateAmount',
    method: 'post',
    data
  })
}

// 导入销售目标明细 /api/sales/SalesRebateApplication/ImportSalesRebateTarget
export function ImportSalesRebateTarget(data) {
  return request({
    url: 'sales/SalesRebateApplication/ImportSalesRebateTarget',
    method: 'post',
    data
  })
}

// 导入返利政策明细 /api/sales/SalesRebateApplication/ImportSalesRebatePolicy
export function ImportSalesRebatePolicy(data) {
  return request({
    url: 'sales/SalesRebateApplication/ImportSalesRebatePolicy',
    method: 'post',
    data
  })
}

// 促销失效
export function SingleLoseEffect(data) {
  return request({
    url: 'sales/PromoteActivity/SingleLoseEffect',
    method: 'post',
    data
  })
}

// 作废策略
export function CancelStrategy(data) {
  return request({
    url: 'sales/StrategyConfig/CancelStrategy',
    method: 'post',
    data
  })
}

// 试算 /api/StrategyConfig/TryCalculate
export function TryCalculate(data) {
  return request({
    url: 'sales/StrategyConfig/TryCalculate',
    method: 'post',
    data
  })
}
// 批量审批
export function BatchApproval(data) {
  return request({
    url: 'sales/FxErpManualTrade/BatchApproval',
    method: 'post',
    data
  })
}
// 查询淘宝闪购物流运费 (Auth) /api/FxErpManualTrade/GetTaobaoFreight
export function GetTaobaoFreight(data) {
  return request({
    url: 'sales/FxErpManualTrade/GetTaobaoFreight',
    method: 'post',
    data
  })
}

// 客户供货价导入  /api/CustomerCategoryGoodsSupplyPrice/ImportGoods
export function ImportGoodsCustomerCategoryGoodsSupplyPrice(data) {
  return request({
    url: 'sales/CustomerCategoryGoodsSupplyPrice/ImportGoods',
    method: 'post',
    data
  })
}
